import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  Platform,
  ActionSheetController
} from "ionic-angular";
import { FormGroup, FormControl } from "@angular/forms";

import { TermsOfServicePage } from "../terms-of-service/terms-of-service";
import { PrivacyPolicyPage } from "../privacy-policy/privacy-policy";

import { WalkthroughPage } from "../walkthrough/walkthrough";

import "rxjs/Rx";

import { ProfileModel } from "../profile/profile.model";
import { ProfileService } from "../profile/profile.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";

import { LanguageService } from "../../providers/language/language.service";
import { LanguageModel } from "../../providers/language/language.model";
import { AppRate } from "@ionic-native/app-rate";
import { SettingsProvider } from "./../../providers/settings/settings";
import { UserProvider } from "../../providers/user/user";

import firebase from "firebase";
import { SuperTabsController } from "ionic2-super-tabs";
import { LoadingProvider } from "../../providers/loading/loading";

@Component({
  selector: "settings-page",
  templateUrl: "settings.html"
})
export class SettingsPage {
  settingsForm: FormGroup;
  selectedTheme: String;
  profile: ProfileModel = new ProfileModel();
  languages: Array<LanguageModel>;
  user: any;
  dark: boolean;
  notifications: boolean = true;
  name: any;
  rank: any;
  avatar: any;
  fees: any;
  theme: any;
  constructor(
    public inAppBrowser: InAppBrowser,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams,
    public nav: NavController,
    public modal: ModalController,
    private settings: SettingsProvider,
    public loadingCtrl: LoadingProvider,
    public languageService: LanguageService,
    public profileService: ProfileService,
    public appRate: AppRate,
    public userservice: UserProvider,
    public platform: Platform,
    private superTabsCtrl: SuperTabsController
  ) {
    this.user = this.navParams.get("user");
    this.name = this.navParams.get("name");
    this.rank = this.navParams.get("rank");
    this.avatar = this.navParams.get("avatar");
    this.fees = this.navParams.get("fees");
    this.theme = this.navParams.get("theme");
    if (this.theme == "light-theme") this.dark = false;
    else this.dark = true;
    this.settings.getActiveTheme().subscribe(val => (this.selectedTheme = val));
    this.languages = this.languageService.getLanguages();

    this.settingsForm = new FormGroup({
      name: new FormControl(),
      location: new FormControl(),
      description: new FormControl(),
      notifications: new FormControl(),
      language: new FormControl()
    });
  }

  ionViewDidLoad() {}

  logout() {
    this.loadingCtrl.show("Signing out...");
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.superTabsCtrl.showToolbar(false);
        this.nav.setRoot("LoginPage");
        this.loadingCtrl.hide();
        console.clear();
      });
  }

  toggleAppTheme() {
    if (this.theme == "light-theme") {
      this.theme = "dark-theme";
    } else {
      this.theme = "light-theme";
    }
    this.userservice.updatetheme(this.theme).then((res: any) => {
      if (res.success) {
        if (!this.dark) {
          this.settings.setActiveTheme("light-theme");
        } else {
          this.settings.setActiveTheme("dark-theme");
        }
      } else {
      }
    });
  }

  showTermsModal() {
    let modal = this.modal.create(TermsOfServicePage);
    modal.present();
  }

  showPrivacyModal() {
    let modal = this.modal.create(PrivacyPolicyPage);
    modal.present();
  }

  visitSite() {
    this.inAppBrowser.create("", "_blank");
  }

  viewBugs() {
    this.nav.push("ViewbugsPage", { user: this.user });
  }

  setLanguage(lang: LanguageModel) {}

  rateApp() {
    this.appRate.preferences.storeAppURL = {
      ios: "1387302520",
      android: "market://details?id=com.nativechain.app"
    };

    this.appRate.promptForRating(true);
  }

  showCopyrightPage() {
    let modal = this.modal.create("CopyrightPage");
    modal.present();
  }

  openImagePicker() {
    //this.nav.push('ChangepicPage', {user:this.user});
    let actionSheet = this.actionSheetCtrl.create({
      enableBackdropDismiss: false,
      title: "Change Profile Picture",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {}
        },
        {
          text: "Upload Picture",
          handler: () => {
            this.nav.push("UploadpicPage", { user: this.user });
          }
        },
        {
          text: "Take a Picture",
          handler: () => {
            this.nav.push("TakepicPage", { user: this.user });
          }
        }
      ]
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts